var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16397 5.8344C9.09917 5.6912 8.95677 5.6 8.79997 5.6H7.19997V0.4C7.19997 0.1792 7.02077 0 6.79997 0H5.19997C4.97917 0 4.79997 0.1792 4.79997 0.4V5.6H3.19998C3.04318 5.6 2.90078 5.692 2.83598 5.8344C2.77038 5.9776 2.79598 6.1448 2.89918 6.2632L5.69917 9.4632C5.77517 9.5504 5.88477 9.6 5.99997 9.6C6.11517 9.6 6.22477 9.5496 6.30077 9.4632L9.10077 6.2632C9.20477 6.1456 9.22877 5.9776 9.16397 5.8344Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 8.8V11.2H1.6V8.8H0V12C0 12.4424 0.3584 12.8 0.8 12.8H11.2C11.6424 12.8 12 12.4424 12 12V8.8H10.4Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.a8f6d184.svg";
export { ForwardRef as ReactComponent };